//our root app component
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PayCategoriesService } from './pay-categories.service';
import { IPayCategory } from './pay-categories.type';

@Component({
	selector: 'app-pilotpay-pay-categories',
	styleUrls: ['./pay-categories.component.scss'],
	templateUrl: './pay-categories.component.html'
})
export class PayCategoriesComponent implements OnInit {
	constructor(private router: Router, private payCategoriesService: PayCategoriesService) {}

	public selectedCategory: string = '';
	public onlyArchived: boolean = false;
	public isLoading: boolean = false;
	public payCategories: IPayCategory[];
	public activePayCategories: IPayCategory[];
	public futurePayCategories: IPayCategory[];
	public archivedPayCategories: IPayCategory[];
	public searchText: string;

	ngOnInit(): void {
		this.getPayCategories(true);
	}

	public changeFilter(): void {
		if (this.onlyArchived) {
			this.getPayArchivedCategories();
		} else {
			this.getPayCategories(true);
		}
	}

	public getPayCategories(includeFuture: boolean = false): void {
		this.archivedPayCategories = [];
		this.payCategories = [];
		this.isLoading = true;
		this.payCategoriesService.getPayCategories(includeFuture).subscribe(
			(DATA: IPayCategory[]) => {
				if (DATA) {
					this.activePayCategories = DATA.filter((cat: IPayCategory) => {
						return cat.isFuture === undefined || !cat.isFuture;
					});
					this.futurePayCategories = DATA.filter((cat: IPayCategory) => {
						return cat.isFuture === true;
					});
					this.payCategories = DATA;
				}
				this.isLoading = false;
			},
			(error: HttpErrorResponse) => {
				console.error(error);
				this.isLoading = false;
			}
		);
	}

	public getPayArchivedCategories(): void {
		this.payCategories = [];
		this.activePayCategories = [];
		this.futurePayCategories = [];
		this.isLoading = true;

		this.payCategoriesService.getPayArchivedCategories().subscribe(
			(DATA: IPayCategory[]) => {
				this.archivedPayCategories = DATA;
				this.isLoading = false;
			},
			(error: HttpErrorResponse) => {
				console.error(error);
				this.isLoading = false;
			}
		);
	}

	public navigate = (category: string, catType: string = 'new', date: string = 'now'): void => {
		this.router
			.navigate(['/pilotpay/pay-categories', category, catType, date])
			.then(() => {
				this.selectedCategory = category;
			})
			.catch((err: Error) => {
				console.error(err);
			});
	};
}
